import { SvgIcon } from "@mui/material"
import React from "react"

type IProps = {
  sx?: any
}

export function IconLink(props: Readonly<IProps>): React.JSX.Element {
  const { sx } = props

  return (
    <SvgIcon
      {...props}
      fillOpacity={0}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sx?.width ? sx?.width : "24",
        height: sx?.height ? sx?.height : "24",
      }}>
      {/*  SVG from https://tablericons.com/ */}

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round">
        <path d="M9 15l6 -6" />
        <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" />
        <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" />
      </svg>
    </SvgIcon>
  )
}
